import { render } from "./Share_Product_Details.vue?vue&type=template&id=480f17c1"
import script from "./Share_Product_Details.vue?vue&type=script&lang=js"
export * from "./Share_Product_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__